import { render, staticRenderFns } from "./LogoSlider.vue?vue&type=template&id=d22f4e86"
import script from "./LogoSlider.vue?vue&type=script&lang=js"
export * from "./LogoSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports